import { render, staticRenderFns } from "./TVShows.vue?vue&type=template&id=6dd4656d&scoped=true&"
import script from "./TVShows.vue?vue&type=script&lang=js&"
export * from "./TVShows.vue?vue&type=script&lang=js&"
import style0 from "./TVShows.vue?vue&type=style&index=0&id=6dd4656d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4656d",
  null
  
)

export default component.exports